import React, { useCallback } from 'react';
import { Button } from 'js/components/common/Button';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

export const LinkCell = ({ name, row }) => {
    const t = useComponentTranslations();
    const open = useCallback(() => {
        window.open(row[name], 'hub2-game-history-details', 'resizable=yes, width=800px, height=600px');
    }, [row, name]);

    return <Button onClick={open} size="small">
        {t(`table.cell.link.${name}`)}
    </Button>;
};
